import { call, put, takeLatest, select, } from 'redux-saga/effects';

import { fetchProducts as actions, } from './actions';
import * as types from './types';
import { ProductsErrorType, } from './types';
import { repositories, } from 'api'
import { getErrorProperties, } from 'common/functions';

export {
    actions,
};

const products = new repositories.products.Collection();

function* fetchProducts(): Generator {
    try {
        const filters = yield select(({ products }) => products.collection.filters);
        const { data, }: any = yield call([ products, 'getAll', ], filters);

        yield put(actions.success(data));
    } catch (error) {
        yield put(actions.failure(getErrorProperties<ProductsErrorType>(error)));
    }
}

function* productsSaga() {
    yield takeLatest(types.FETCH_PRODUCTS_REQUEST, fetchProducts);
}

export default productsSaga;
